<template>
  <div class="bg-bg-secondary rounded-tr p-12">
    <GoalImagePickerPreview :goal-image="goalImage"
                            @toggleImagePicker="$emit('toggleImagePicker')"/>
    <div>
      <div class="mb-9-5 text-bg-contractor font-bold">
        <div class="text-md mb-2 leading-normal">{{ $t('monthlyPayment') }}</div>
        <div class="text-xl">{{ monthlyPayment || '–' }}</div>
      </div>
      <div class="mb-9-5 text-bg-contractor font-bold">
        <div class="text-md mb-2 leading-normal">{{ $t('achievementDate') }}</div>
        <div class="text-xl capitalize">{{ finishAt || '–' }}</div>
      </div>
      <div class="mb-9-5 text-bg-contractor font-bold">
        <div class="text-md mb-2 leading-normal">{{ $t('monthsAmount') }}</div>
        <div class="text-xl">{{ months || '–' }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import GoalImagePickerPreview from "@/components/cabinet/Money/Goals/GoalImagePicker/GoalImagePickerPreview";

export default {
  name: "GoalCreatePreview",
  components: {GoalImagePickerPreview},
  props: [
    'monthlyPayment',
    'finishAt',
    'months',
    'goalImage'
  ],
  i18n: {
    messages: {
      en: {
        monthlyPayment: 'Monthly payment for the purpose',
        achievementDate: 'The date the goal was achieved',
        monthsAmount: 'Number of months',
      },
      ru: {
        monthlyPayment: 'Ежемесячный платеж по цели',
        achievementDate: 'Дата достижения цели',
        monthsAmount: 'Количество месяцев',
      }
    }
  }
}
</script>